import React, {
  FC,
  useRef,
  useEffect,
  useState,
  ChangeEvent,
  useMemo,
} from "react";
import useSpinnerLoader from "../../../../shared/components/spinner-loader";
import { Table } from "react-bootstrap";
import { notificationService } from "../../../../shared/services/notification-service";
import { apiEmployeeService } from "../../../../shared/services/employee-service";
import { initialResponseData } from "../../../../shared/utils/constants";
import { ReportInOutLeaveService } from "../../../../shared/services/Report/ReportInOutLeave/report-in-out-leave";
import PaginationForm from "../../../../shared/components/molecules/commons/pagination-form";
import TableRowNoData from "../../../../shared/components/molecules/commons/table-row-no-data";
import { AxiosError } from "axios/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import InputSelect from "../../../../shared/components/atoms/input-select";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import Moment from "moment";
import { useAuth } from "../../../../shared/authentications/auth-context";
import { getBangkokMoment } from "../../../../shared/utils/functions-date-time";

import {
  fetchDepartmentsOfficeNameOptions,
  fetchDivisionGroupOfficeNameOptions,
  fetchDepartmentsNameOptions,
  fetchPositionNameOptions,
  fetchLeaveTypeOptions,
  department_offices_name_Options,
  division_group_office_name_Options,
  departments_name_Options,
  position_name_Options,
  leave_type_Options,
} from "../../OptionsDropDown";

import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import {
  Document,
  Page,
  Text,
  View,
  PDFDownloadLink,
  Font,
} from "@react-pdf/renderer";

import MonthYearInput from "../../../../shared/components/atoms/month-year-input";
import { apiHolidaysService } from "../../../../shared/services/holidays-service";

Font.register({
  family: "kanit-regular",
  src: "https://fonts.gstatic.com/s/sarabun/v17/DtVjJx26TKEr37c9WBI.ttf",
});
Font.register({
  family: "kanit-200",
  src: "https://fonts.gstatic.com/s/sarabun/v17/DtVmJx26TKEr37c9YL5rulw.ttf",
});

const ReportInOutLeaveDetailPage: FC = () => {
  const { authJwt } = useAuth();
  const isAdmin = authJwt?.role === "ADMIN";
  const [isUserLoaded, setIsUserLoaded] = useState(false);

  interface EmployeeMe {
    employee_id: number;
    prefix_name_th: string;
    firstname_th: string;
    lastname_th: string;
    employee_code: string;
    leave_detail_days: Array<{
      day: number;
      leave_type_name: string | null;
      total_leave_time: string | null;
      status: string | null;
    }>;
  }

  interface EmployeeMe {
    employee_id: number;
    prefix_name_th: string;
    firstname_th: string;
    lastname_th: string;
    employee_code: string;
    leave_detail_days: Array<{
      day: number;
      leave_type_name: string | null;
      total_leave_time: string | null;
      status: string | null;
    }>;
  }

  const [isMe, setIsMe] = useState<EmployeeMe | undefined>();

  const getEmployeeMe = async () => {
    const response = await apiEmployeeService.getEmployeeMe();

    // if(response.length !== 0) {
    //   let currentJob = response.job_positions.find((v: any) => v.is_currently);
    //   console.log('AAA', currentJob);
    // }

    if (response.length !== 0 && !isAdmin) {
      let arr: Array<any> = response.job_positions.filter(
        (v: any) => v.is_currently
      );
      let division_group_office_name =
        arr.at(0)?.division_group_office_name || "";
      setIsUserLoaded(true);
      setQueryParams({
        ...queryParams,
        division_group_office_name: division_group_office_name,
      });
    } else {
      setIsUserLoaded(true);
      setQueryParams(queryParams);
    }
  };

  useEffect(() => {
    getEmployeeMe();
  }, []);

  //

  // let { day, month, year }: any = useParams();
  // let { day, month, year }: any = useState<any>({
  //   day: parseInt(Moment().format('MM')),
  //   month: parseInt(Moment().format('DD')),
  //   year: parseInt(Moment().format('YYYY')+543)
  // });

  const { loaderComponent, startLoading, stopLoading } = useSpinnerLoader();

  const [data, setData] = useState(initialResponseData);
  const [dataMain, setDataMain] = useState<any>({});
  const [queryParams, setQueryParams] = useState({
    department_offices_name: "",
    division_group_office_name: "",
    structure_departments_name: "",
    position_name: "",
    //date: `${year - 543}-${month}-${day}`,
    date: Moment().format("YYYY-MM-DD"),
    search: "",
    page: 1,
    page_size: 10,
  });

  const fetchData = async () => {
    if (!isUserLoaded) {
      return;
    }

    setQueryParamsExport({ ...queryParamsExport, user_id: "-" });

    startLoading();
    try {
      const result = await ReportInOutLeaveService.getReportInOutLeaveDetail(
        isAdmin
          ? queryParams
          : {
              division_group_office_name:
                queryParams.division_group_office_name,
              structure_departments_name:
                queryParams.structure_departments_name,
              position_name: queryParams.position_name,
              date: queryParams.date,
              search: queryParams.search,
              page: queryParams.page,
              page_size: queryParams.page_size,
            }
      );
      // {
      //   result.rows?.map(async (data1: any) => {
      //     data1.userData = null;
      //     try {
      //       data1.userData = await apiEmployeeService.getEmployeeDetail(
      //         data1.employee_id
      //       );
      //     } catch (e) {
      //       const err = e as AxiosError;
      //       if (err.request.status != 404) {
      //         console.log(err);
      //       }
      //     }
      //   });
      // }

      setData(result);
      setDataMain(result);
    } catch (error) {
      const err = error as AxiosError;
      notificationService.dangerNotification(
        "โหลดข้อมูลไม่สำเร็จ",
        err.message
      );
    } finally {
      stopLoading();
    }
  };

  const [dataExportAll, setDataExportAll] = useState({ count: 0, row: [] });

  const refButtonExport = useRef<(HTMLDivElement | null)[]>([]);
  const [dataExport, setDataExport] = useState({ count: 0, row: [] });

  const [queryParamsExport, setQueryParamsExport] = useState({
    user_id: "-",
    // month: month,
    month: parseInt(Moment(queryParams.date).format("MM")),
    //year: year - 543,
    year: parseInt(Moment(queryParams.date).format("YYYY")),
  });

  const fetchDataExport = async () => {
    try {
      if (queryParamsExport.user_id == "") {
        setDataExportAll(
          await ReportInOutLeaveService.getReportInOutLeaveDetail_Export(
            queryParamsExport
          )
        );
        setDataExport({ count: 0, row: [] });
      } else {
        setDataExport(
          await ReportInOutLeaveService.getReportInOutLeaveDetail_Export(
            queryParamsExport
          )
        );
        setDataExportAll({ count: 0, row: [] });
      }
    } catch (error) {
      const err = error as AxiosError;
      notificationService.dangerNotification(
        "โหลดข้อมูลไม่สำเร็จ",
        err.message
      );
    }
  };

  const tableRowNoData = () => {
    if (data.rows?.length === 0) {
      return (
        <TableRowNoData
          colspan={
            6 +
            leave_type_Options.slice(1).length +
            leave_type_Options.slice(1).length
          }
        />
      );
    }
    return null;
  };

  const onChangePageSize = (page_size: number) => {
    setQueryParams({
      ...queryParams,
      page_size: page_size,
    });
  };

  const onChangePage = (page: number) => {
    setQueryParams({
      ...queryParams,
      page: page,
    });
  };

  useEffect(() => {
    fetchData();
  }, [
    queryParams.department_offices_name,
    queryParams.division_group_office_name,
    queryParams.structure_departments_name,
    queryParams.position_name,
    queryParams.page_size,
    queryParams.page,
    queryParams.date,
    isUserLoaded,
  ]);

  useEffect(() => {
    queryParamsExport.user_id !== "-"
      ? fetchDataExport()
      : setDataExport({ count: 0, row: [] });
    setDataExportAll({ count: 0, row: [] });
  }, [queryParamsExport.user_id]);

  // useEffect(() => {
  //   console.log("dataExportAll", dataExportAll);
  //   console.log("dataExport", dataExport);
  // }, [dataExportAll, dataExport]);

  useEffect(() => {
    fetchDepartmentsOfficeNameOptions();
    fetchDivisionGroupOfficeNameOptions();
    fetchDepartmentsNameOptions();
    fetchPositionNameOptions();
    fetchLeaveTypeOptions();
  }, []);

  const thaiMonths = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];

  const getThaiDayName = useMemo(
    () => (dateString: string) => {
      let date;
      if (dateString.includes("T")) {
        const [datePart] = dateString.split("T");
        date = Moment(datePart).toDate();
      } else {
        date = Moment(dateString).toDate();
      }
      const daysInThai = ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];
      return daysInThai[date.getDay()];
    },
    []
  );

  const formatDate = useMemo(
    () => (dateString: string) => {
      if (dateString.includes("T")) {
        const [datePart] = dateString.split("T");
        return Moment(datePart).format("DD");
      }
      return Moment(dateString).format("DD");
    },
    []
  );
  const fDaysInMonth = (month: any, year: any) => {
    return new Date(year, month, 0).getDate();
  };

  //let daysInMonth = fDaysInMonth(month, year-543);
  let daysInMonth = fDaysInMonth(
    Moment(queryParams.date).format("MM"),
    parseInt(Moment(queryParams.date).format("YYYY"))
  );
  let daysInMonthArr: any = [];
  for (let i = 0; i < daysInMonth; ++i) {
    daysInMonthArr[i] = i + 1;
  }
  // console.log('daysInMonth', daysInMonth);

  const [restDayList, setRestDayList] = useState([] as any[]);

  const getHolidaysActive = async () => {
    try {
      const response = await apiHolidaysService.getHolidaysActive();
      const restDayList = response.map((data: any) => {
        // Convert Buddhist year to Gregorian year and format the date
        const date = Moment(data.holidayDate)
          .year(Moment(data.holidayDate).year()) // Convert Buddhist year to Gregorian
          .format("YYYY-MM-DD"); // Format as YYYY-MM-DD

        return { date };
      });
      setRestDayList(restDayList);
    } catch (error) {
      console.error("Error fetching holidays:", error);
      return [];
    }
  };

  // let today = Moment('2024-05-15');
  let today = Moment();

  const DivReport: React.FC<{ data: any }> = ({ data }) => (
    <div style={{ padding: 10 }}>
      <div style={{ textAlign: "center", marginBottom: 3 }}>
        <h3>องค์การตลาดเพื่อเกษตรกร</h3>
        <h3>รายงานการปฏิบัติงานของพนักงาน</h3>
        <p>
          {(() => {
            let html = "";

            data.row?.map((data1: any, index1: any) => {
              dataMain.rows
                .filter((data3: any) => {
                  return data3.user_id == data1.user?.id;
                })
                .map((data3: any) => {
                  if (data3) {
                    data3.userData?.job_positions
                      .filter((data2: any) => {
                        return data2.is_currently;
                      })
                      .map((data2: any) => {
                        if (data2.division_group_office_name) {
                          html =
                            "กอง " + data2.division_group_office_name + " ";
                        }
                      });
                  }
                });
            });

            return html;
          })()}
          {thaiMonths[parseInt(Moment(queryParams.date).format("MM")) - 1]}{" "}
          {parseInt(Moment(queryParams.date).format("YYYY")) + 543}
        </p>
      </div>

      <div style={{ marginBottom: 10 }}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ width: "12%", fontWeight: "bold" }}>รหัสพนักงาน</div>
          <div style={{ width: "25%", fontWeight: "bold" }}>ชื่อ-นามสกุล</div>
          <div style={{ width: "10%", fontWeight: "bold" }}>วันที่</div>
          <div style={{ width: "8%", fontWeight: "bold" }}>เวลาเข้า</div>
          <div style={{ width: "13%" }}></div>
          <div style={{ width: "8%", fontWeight: "bold" }}>เวลาออก</div>
          <div style={{ width: "13%" }}></div>
        </div>

        {/* ไม่มีข้อมูลการเข้างาน */}
        {data.row.length === 0 && isMe && (
          <>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div
                style={{
                  width: "12%",
                }}
              >
                {isMe.employee_code}
              </div>
              <div
                style={{
                  width: "25%",
                }}
              >
                {isMe.prefix_name_th +
                  isMe.firstname_th +
                  " " +
                  isMe.lastname_th}
              </div>
            </div>

            {daysInMonthArr.map((day: any) => {
              const currentDate = Moment()
                .set("year", parseInt(Moment(queryParams.date).format("YYYY")))
                .set(
                  "month",
                  parseInt(Moment(queryParams.date).format("MM")) - 1
                )
                .set("date", day);

              const isRestDay = restDayList.find(
                (v: any) => v.date === currentDate.format("YYYY-MM-DD")
              );

              return (
                <div
                  key={day}
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  <div style={{ width: "37%", marginLeft: 10 }}></div>
                  <div
                    style={{
                      width: "10%",
                    }}
                  >
                    {getThaiDayName(currentDate.format("YYYY-MM-DD")) +
                      " " +
                      formatDate(currentDate.format())}
                  </div>
                  <div
                    style={{
                      width: "8%",
                    }}
                  >
                    {"-"}
                  </div>
                  <div
                    style={{
                      width: "13%",
                    }}
                  >
                    {isRestDay
                      ? "วันหยุดนักขัตฤกษ์"
                      : getBangkokMoment(currentDate).day() === 0
                      ? "วันหยุดอาทิตย์"
                      : getBangkokMoment(currentDate).day() === 6
                      ? "วันหยุดเสาร์"
                      : "ขาดงาน"}
                  </div>
                  <div
                    style={{
                      width: "8%",
                    }}
                  >
                    {"-"}
                  </div>
                  <div
                    style={{
                      width: "13%",
                    }}
                  >
                    {""}
                  </div>
                </div>
              );
            })}

            <div style={{ marginTop: 10 }} />
          </>
        )}

        {data.row?.map((data1: any, index1: any) => {
          return (
            <>
              <div
                key={index1}
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div style={{ width: "12%" }}>{data1.user?.code}</div>
                <div style={{ width: "25%" }}>
                  {data1.user?.prefix_name_th +
                    data1.user?.firstname_th +
                    " " +
                    data1.user?.lastname_th}
                </div>
              </div>

              {daysInMonthArr.map((day: any) => {
                let found = false;
                let html: any;

                // สร้างวันที่ปัจจุบันจาก day
                const currentDate = Moment()
                  .set(
                    "year",
                    parseInt(Moment(queryParams.date).format("YYYY"))
                  )
                  .set(
                    "month",
                    parseInt(Moment(queryParams.date).format("MM")) - 1
                  )
                  .set("date", day);

                data1.data?.map((data2: any, index2: any) => {
                  let d = Moment(data2.date);

                  if (parseInt(Moment(data2.date).utc().format("DD")) == day) {
                    
                    let time1 = data2.first_check_in_time?.substring(11, 19);
                    let time2 = data2.last_check_in_time?.substring(11, 19);

                    let timePos1 =
                      time1 < "13:00:00"
                        ? time1
                        : time2 < "13:00:00"
                        ? time2
                        : "";
                    let timePos2 =
                      time2 >= "13:00:00"
                        ? time2
                        : time2 < "13:00:00" && time2 !== ""
                        ? time2
                        : time1 >= "13:00:00"
                        ? time1
                        : "";

                    let isNotLate = false;
                    if (timePos1 && timePos2) {
                      // กรณีเข้างานก่อน 8:30 สามารถออกงาน 16:30 ได้
                      if (timePos1 <= "08:30:00") {
                        isNotLate = timePos2 >= "16:30:00";
                      }
                      // กรณีเข้างาน 8:31-8:45 ต้องออกงาน 16:45 ขึ้นไป
                      else if (
                        timePos1 > "08:30:00" &&
                        timePos1 <= "08:45:00"
                      ) {
                        isNotLate = timePos2 >= "16:45:00";
                      }
                    }
                    let isDefinitelyLate =
                      timePos1 &&
                      timePos1 >= "08:46:00" &&
                      timePos1 < "10:00:00";
                    let isOutEarly = timePos2 && timePos2 < "16:30:00";

                    let isMissed = false;
                    let leaveFirstHalf = false;
                    let leaveLastHalf = false;
                    let leaveFull = false;
                    let leaveTypeName = null;

                    let isRestDay = restDayList.find(
                      (v: any) => v.date == currentDate.format("YYYY-MM-DD")
                    );

                    // ปรับ IIFE สำหรับตรวจสอบการลา
                    (() => {
                      dataMain.rows
                        .filter((data3: any) => data3.user_id == data1.user?.id)
                        .forEach((data3: any) => {
                          data3.leave_detail.forEach((leave: any) => {
                            if (leave.status === "approved") {
                              const startDate = Moment(leave.start_date);
                              const endDate = Moment(leave.end_date);

                              // ตรวจสอบว่าวันปัจจุบันอยู่ในช่วงวันลาหรือไม่
                              if (
                                currentDate.isBetween(
                                  startDate,
                                  endDate,
                                  "day",
                                  "[]"
                                )
                              ) {
                                if (leave.total_leave_time === "ครึ่งวันเช้า") {
                                  leaveFirstHalf = true;
                                } else if (
                                  leave.total_leave_time === "ครึ่งวันบ่าย"
                                ) {
                                  leaveLastHalf = true;
                                } else if (
                                  leave.total_leave_time === "เต็มวัน"
                                ) {
                                  leaveFull = true;
                                }

                                if (leave.leave_type_name) {
                                  leaveTypeName = leave.leave_type_name;
                                  if (leaveFirstHalf) {
                                    leaveTypeName += " (เช้า)";
                                  } else if (leaveLastHalf) {
                                    leaveTypeName += " (บ่าย)";
                                  }
                                }
                              }
                            }
                          });
                        });
                    })();

                    // กรณีไม่ได้ลงเวลาเข้างาน
                    if (!timePos1 && !timePos2) {
                      isMissed = true;
                    }

                    found = true;

                    html = (
                      <div
                        key={index2}
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <div style={{ width: "37%", marginLeft: 10 }}></div>
                        <div style={{ width: "10%" }}>
                          {getThaiDayName(data2.date) +
                            " " +
                            formatDate(data2.date)}
                        </div>
                        <div style={{ width: "8%" }}>
                          {timePos1 ? timePos1 : "-"}
                        </div>
                        <div style={{ width: "13%" }}>
                          {(() => {
                            let html2: any = "";

                            if (d.isSameOrBefore(today)) {
                              if (isRestDay) {
                                html2 += ` วันหยุดนักขัตฤกษ์`;
                              } else if (
                                getBangkokMoment(d).day() === 0 &&
                                (!timePos1 || !timePos2)
                              ) {
                                html2 += ` วันหยุดอาทิตย์`;
                              } else if (
                                getBangkokMoment(d).day() === 6 &&
                                (!timePos1 || !timePos2)
                              ) {
                                html2 += ` วันหยุดเสาร์`;
                              } else {
                                if (
                                  !timePos1 &&
                                  timePos2 &&
                                  !leaveTypeName
                                ) {
                                  html2 += `  ขาดครึ่งวันเช้า`;
                                } else if (
                                  timePos1 &&
                                  !timePos2 &&
                                  !leaveTypeName
                                ) {
                                  html2 += `  ขาดครึ่งวันบ่าย`;
                                } else if (isDefinitelyLate && !isNotLate) {
                                  html2 += ` สาย`;
                                } else if (isMissed) {
                                  html2 += ` ขาดงาน`;
                                } else if (leaveFirstHalf) {
                                  if (
                                    !timePos1 ||
                                    timePos1 >= "13:00:00" ||
                                    !timePos2
                                  ) {
                                    html2 += ` ขาดครึ่งวันบ่าย`;
                                  }
                                } else if (leaveLastHalf) {
                                  if (!timePos1 || timePos1 >= "10:00:00") {
                                    html2 += ` ขาดครึ่งวันเช้า`;
                                  }
                                } else if (!leaveFull) {
                                  if (!timePos1) {
                                    html2 += ` ขาดงาน`;
                                  } else if (
                                    timePos1 >= "10:00:00" &&
                                    timePos1 < "13:00:00"
                                  ) {
                                    html2 += ` ขาดครึ่งวันเช้า`;
                                  } else if (
                                    timePos1 >= "13:00:00" ||
                                    !timePos2
                                  ) {
                                    html2 += ` ขาดครึ่งวันบ่าย`;
                                  }
                                }
                                if (
                                  leaveFirstHalf ||
                                  leaveLastHalf ||
                                  leaveFull
                                ) {
                                  html2 += ` ${leaveTypeName}`;
                                }
                              }
                            }

                            html2 = html2.trim();
                            return html2;
                          })()}
                        </div>
                        <div style={{ width: "8%" }}>
                          {timePos2 ? timePos2 : "-"}
                        </div>
                        <div style={{ width: "13%" }}>
                          {(() => {
                            let html2: any = "";
                            if (d.isSameOrBefore(today)) {
                              if (isOutEarly && !leaveLastHalf) {
                                html2 += ` ออกก่อนเวลา`;
                              }
                            }
                            html2 = html2.trim();
                            return html2;
                          })()}
                        </div>
                      </div>
                    );
                  }

                  // กรณีไม่พบข้อมูลการเข้างาน
                  if (!found) {
                    let leaveTypeName = null;
                    let leaveFull = false;

                    // ปรับ IIFE สำหรับตรวจสอบการลาในวันที่ไม่มีข้อมูลการเข้างาน
                    (() => {
                      dataMain.rows
                        .filter((data3: any) => data3.user_id == data1.user?.id)
                        .forEach((data3: any) => {
                          data3.leave_detail.forEach((leave: any) => {
                            if (leave.status === "approved") {
                              const startDate = Moment(leave.start_date);
                              const endDate = Moment(leave.end_date);

                              if (
                                currentDate.isBetween(
                                  startDate,
                                  endDate,
                                  "day",
                                  "[]"
                                )
                              ) {
                                if (leave.total_leave_time === "เต็มวัน") {
                                  leaveFull = true;
                                }
                                if (leave.leave_type_name) {
                                  leaveTypeName = leave.leave_type_name;
                                }
                              }
                            }
                          });
                        });
                    })();

                    // เช็ควันหยุด
                    let isRestDay = restDayList.find(
                      (v: any) => v.date == currentDate.format("YYYY-MM-DD")
                    );

                    // สร้าง View สำหรับวันที่ไม่มีข้อมูลการเข้างาน
                    html = (
                      <div
                        key={day}
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <div style={{ width: "37%", marginLeft: 10 }}></div>
                        <div style={{ width: "10%" }}>
                          {getThaiDayName(currentDate.format("YYYY-MM-DD")) +
                            " " +
                            formatDate(currentDate.format())}
                        </div>
                        <div style={{ width: "8%" }}>{"-"}</div>
                        <div style={{ width: "13%" }}>
                          {(() => {
                            let html2: any = "";

                            if (currentDate.isSameOrBefore(today)) {
                              if (isRestDay) {
                                html2 += ` วันหยุดนักขัตฤกษ์`;
                              } else if (
                                getBangkokMoment(currentDate).day() === 0
                              ) {
                                html2 += ` วันหยุดอาทิตย์`;
                              } else if (
                                getBangkokMoment(currentDate).day() === 6
                              ) {
                                html2 += ` วันหยุดเสาร์`;
                              } else {
                                if (!leaveFull) {
                                  if (
                                    [1, 2, 3, 4, 5].includes(
                                      getBangkokMoment(currentDate).day()
                                    )
                                  ) {
                                    html2 += ` ขาดงาน`;
                                  }
                                }
                                if (leaveTypeName) {
                                  html2 += ` ${leaveTypeName}`;
                                }
                              }
                            }

                            html2 = html2.trim();
                            return html2;
                          })()}
                        </div>
                        <div style={{ width: "8%" }}>{"-"}</div>
                        <div style={{ width: "13%" }}>{""}</div>
                      </div>
                    );
                  }
                });

                return html;
              })}

              <div style={{ marginTop: 10 }} />
            </>
          );
        })}
      </div>
    </div>
  );

  const PDF: React.FC<{ data: any }> = ({ data }) => (
    <Document>
      <Page size="A4" style={{ padding: 10 }}>
        <View>
          <Text
            style={{
              fontFamily: "kanit-regular",
              fontSize: 13,
              textAlign: "center",
              marginBottom: 3,
            }}
          >
            องค์การตลาดเพื่อเกษตรกร
          </Text>

          <Text
            style={{
              fontFamily: "kanit-regular",
              fontSize: 13,
              textAlign: "center",
              marginBottom: 3,
            }}
          >
            รายงานการปฏิบัติงานของพนักงาน
          </Text>

          <Text
            style={{
              fontFamily: "kanit-regular",
              fontSize: 12,
              textAlign: "center",
              marginBottom: 10,
            }}
          >
            {(() => {
              let html = "";

              data.row?.map((data1: any, index1: any) => {
                dataMain.rows
                  .filter((data3: any) => {
                    return data3.user_id == data1.user?.id;
                  })
                  .map((data3: any) => {
                    if (data3) {
                      data3.userData?.job_positions
                        .filter((data2: any) => {
                          return data2.is_currently;
                        })
                        .map((data2: any) => {
                          if (data2.division_group_office_name) {
                            html =
                              "กอง " + data2.division_group_office_name + " ";
                          }
                        });
                    }
                  });
              });

              return html;
              // กองทรัพยากรบุคคล
            })()}
            {thaiMonths[parseInt(Moment(queryParams.date).format("MM")) - 1]}{" "}
            {parseInt(Moment(queryParams.date).format("YYYY")) + 543}
          </Text>

          <View style={{ marginBottom: 10 }} fixed>
            <View style={{ flexDirection: "row" }}>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "12%",
                  fontSize: 11,
                  textAlign: "left",
                  marginLeft: 5,
                }}
              >
                รหัสพนักงาน
              </Text>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "25%",
                  fontSize: 11,
                  textAlign: "left",
                  marginLeft: 5,
                }}
              >
                ชื่อ-นามสกุล
              </Text>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "10%",
                  fontSize: 11,
                  textAlign: "left",
                  marginLeft: 5,
                }}
              >
                วันที่
              </Text>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "8%",
                  fontSize: 11,
                  textAlign: "left",
                  marginLeft: 5,
                }}
              >
                เวลาเข้า
              </Text>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "13%",
                  fontSize: 11,
                  textAlign: "left",
                  marginLeft: 5,
                }}
              ></Text>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "8%",
                  fontSize: 11,
                  textAlign: "left",
                  marginLeft: 5,
                }}
              >
                เวลาออก
              </Text>
              <Text
                style={{
                  fontFamily: "kanit-regular",
                  width: "13%",
                  fontSize: 11,
                  textAlign: "left",
                  marginLeft: 5,
                }}
              ></Text>
            </View>

            {/* {
              (() => {
                  console.log('================');
                  console.log('queryParamsExport.user_id >', queryParamsExport.user_id, '<');
                  console.log('queryParamsExport.user_id >' + queryParamsExport.user_id + '<');
                  console.log('dataMain', dataMain);
                  console.log('dataExport', dataExport);
                  console.log('data', data);
                  return '';
              })()
            } */}

            {data.row.length === 0 && isMe && (
              <>
                <View style={{ flexDirection: "row" }}>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "12%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    {isMe.employee_code}
                  </Text>
                  <Text
                    style={{
                      fontFamily: "kanit-200",
                      width: "25%",
                      fontSize: 10,
                      textAlign: "left",
                      marginLeft: 5,
                    }}
                  >
                    {isMe.prefix_name_th +
                      isMe.firstname_th +
                      " " +
                      isMe.lastname_th}
                  </Text>
                </View>

                {daysInMonthArr.map((day: any) => {
                  const currentDate = Moment()
                    .set(
                      "year",
                      parseInt(Moment(queryParams.date).format("YYYY"))
                    )
                    .set(
                      "month",
                      parseInt(Moment(queryParams.date).format("MM")) - 1
                    )
                    .set("date", day);

                  const isRestDay = restDayList.find(
                    (v: any) => v.date === currentDate.format("YYYY-MM-DD")
                  );

                  return (
                    <View key={day} style={{ flexDirection: "row" }}>
                      <View style={{ width: "37%", marginLeft: 10 }}></View>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "10%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        {getThaiDayName(currentDate.format("YYYY-MM-DD")) +
                          " " +
                          formatDate(currentDate.format())}
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "8%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        {"-"}
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "13%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        {isRestDay
                          ? "วันหยุดนักขัตฤกษ์"
                          : getBangkokMoment(currentDate).day() === 0
                          ? "วันหยุดอาทิตย์"
                          : getBangkokMoment(currentDate).day() === 6
                          ? "วันหยุดเสาร์"
                          : "ขาดงาน"}
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "8%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        {"-"}
                      </Text>
                      <Text
                        style={{
                          fontFamily: "kanit-200",
                          width: "13%",
                          fontSize: 10,
                          textAlign: "left",
                          marginLeft: 5,
                        }}
                      >
                        {""}
                      </Text>
                    </View>
                  );
                })}

                <View style={{ marginTop: 10 }} />
              </>
            )}

            {data.row?.map((data1: any, index1: any) => {
              return (
                <>
                  <View key={index1} style={{ flexDirection: "row" }}>
                    <Text
                      style={{
                        fontFamily: "kanit-200",
                        width: "12%",
                        fontSize: 10,
                        textAlign: "left",
                        marginLeft: 5,
                      }}
                    >
                      {data1.user?.code}
                    </Text>
                    <Text
                      style={{
                        fontFamily: "kanit-200",
                        width: "25%",
                        fontSize: 10,
                        textAlign: "left",
                        marginLeft: 5,
                      }}
                    >
                      {data1.user?.prefix_name_th +
                        data1.user?.firstname_th +
                        " " +
                        data1.user?.lastname_th}
                    </Text>
                  </View>

                  {daysInMonthArr.map((day: any) => {
                    let found = false;
                    let html: any;

                    // สร้างวันที่ปัจจุบันจาก day
                    const currentDate = Moment()
                      .set(
                        "year",
                        parseInt(Moment(queryParams.date).format("YYYY"))
                      )
                      .set(
                        "month",
                        parseInt(Moment(queryParams.date).format("MM")) - 1
                      )
                      .set("date", day);

                    data1.data?.map((data2: any, index2: any) => {
                      let d = Moment(data2.date);

                      if (
                        parseInt(Moment(data2.date).utc().format("DD")) == day
                      ) {
                        let time1 = data2.first_check_in_time?.substring(11, 19);
                        let time2 = data2.last_check_in_time?.substring(11, 19);

                        let timePos1 =
                          time1 < "13:00:00"
                            ? time1
                            : time2 < "13:00:00"
                            ? time2
                            : "";

                        let timePos2 =
                          time2 >= "13:00:00"
                            ? time2
                            : time2 < "13:00:00" && time2 !== ""
                            ? time2
                            : time1 >= "13:00:00"
                            ? time1
                            : "";

                        let isNotLate = false;
                        if (timePos1 && timePos2) {
                          // กรณีเข้างานก่อน 8:30 สามารถออกงาน 16:30 ได้
                          if (timePos1 <= "08:30:00") {
                            isNotLate = timePos2 >= "16:30:00";
                          }
                          // กรณีเข้างาน 8:31-8:45 ต้องออกงาน 16:45 ขึ้นไป
                          else if (
                            timePos1 > "08:30:00" &&
                            timePos1 <= "08:45:00"
                          ) {
                            isNotLate = timePos2 >= "16:45:00";
                          }
                        }
                        let isDefinitelyLate =
                          timePos1 &&
                          timePos1 >= "08:46:00" &&
                          timePos1 < "10:00:00";
                        let isOutEarly = timePos2 && timePos2 < "16:30:00";

                        let isMissed = false;
                        let leaveFirstHalf = false;
                        let leaveLastHalf = false;
                        let leaveFull = false;
                        let leaveTypeName = null;

                        let isRestDay = restDayList.find(
                          (v: any) => v.date == currentDate.format("YYYY-MM-DD")
                        );

                        // ปรับ IIFE สำหรับตรวจสอบการลา
                        (() => {
                          dataMain.rows
                            .filter(
                              (data3: any) => data3.user_id == data1.user?.id
                            )
                            .forEach((data3: any) => {
                              data3.leave_detail.forEach((leave: any) => {
                                if (leave.status === "approved") {
                                  const startDate = Moment(leave.start_date);
                                  const endDate = Moment(leave.end_date);

                                  // ตรวจสอบว่าวันปัจจุบันอยู่ในช่วงวันลาหรือไม่
                                  if (
                                    currentDate.isBetween(
                                      startDate,
                                      endDate,
                                      "day",
                                      "[]"
                                    )
                                  ) {
                                    if (
                                      leave.total_leave_time === "ครึ่งวันเช้า"
                                    ) {
                                      leaveFirstHalf = true;
                                    } else if (
                                      leave.total_leave_time === "ครึ่งวันบ่าย"
                                    ) {
                                      leaveLastHalf = true;
                                    } else if (
                                      leave.total_leave_time === "เต็มวัน"
                                    ) {
                                      leaveFull = true;
                                    }

                                    if (leave.leave_type_name) {
                                      leaveTypeName = leave.leave_type_name;
                                      if (leaveFirstHalf) {
                                        leaveTypeName += " (เช้า)";
                                      } else if (leaveLastHalf) {
                                        leaveTypeName += " (บ่าย)";
                                      }
                                    }
                                  }
                                }
                              });
                            });
                        })();

                        // กรณีไม่ได้ลงเวลาเข้างาน
                        if (!timePos1 && !timePos2) {
                          isMissed = true;
                        }

                        found = true;

                        html = (
                          <View key={index2} style={{ flexDirection: "row" }}>
                            <View
                              style={{ width: "37%", marginLeft: 10 }}
                            ></View>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "10%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {getThaiDayName(data2.date) +
                                " " +
                                formatDate(data2.date)}
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "8%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {timePos1 ? timePos1 : "-"}
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "13%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {(() => {
                                let html2: any = "";

                                if (d.isSameOrBefore(today)) {
                                  if (isRestDay) {
                                    html2 += ` วันหยุดนักขัตฤกษ์`;
                                  } else if (
                                    getBangkokMoment(d).day() === 0 &&
                                    (!timePos1 || !timePos2)
                                  ) {
                                    html2 += ` วันหยุดอาทิตย์`;
                                  } else if (
                                    getBangkokMoment(d).day() === 6 &&
                                    (!timePos1 || !timePos2)
                                  ) {
                                    html2 += ` วันหยุดเสาร์`;
                                  } else {
                                    if (
                                      !timePos1 &&
                                      timePos2 &&
                                      !leaveTypeName
                                    ) {
                                      html2 += `  ขาดครึ่งวันเช้า`;
                                    } else if (
                                      timePos1 &&
                                      !timePos2 &&
                                      !leaveTypeName
                                    ) {
                                      html2 += `  ขาดครึ่งวันบ่าย`;
                                    } else if (isDefinitelyLate && !isNotLate) {
                                      html2 += ` สาย`;
                                    } else if (isMissed) {
                                      html2 += ` ขาดงาน`;
                                    } else if (leaveFirstHalf) {
                                      if (
                                        !timePos1 ||
                                        timePos1 >= "13:00:00" ||
                                        !timePos2
                                      ) {
                                        html2 += ` ขาดครึ่งวันบ่าย`;
                                      }
                                    } else if (leaveLastHalf) {
                                      if (!timePos1 || timePos1 >= "10:00:00") {
                                        html2 += ` ขาดครึ่งวันเช้า`;
                                      }
                                    } else if (!leaveFull) {
                                      if (!timePos1) {
                                        html2 += ` ขาดงาน`;
                                      } else if (
                                        timePos1 >= "10:00:00" &&
                                        timePos1 < "13:00:00"
                                      ) {
                                        html2 += ` ขาดครึ่งวันเช้า`;
                                      } else if (
                                        timePos1 >= "13:00:00" ||
                                        !timePos2
                                      ) {
                                        html2 += ` ขาดครึ่งวันบ่าย`;
                                      }
                                    }
                                    if (
                                      leaveFirstHalf ||
                                      leaveLastHalf ||
                                      leaveFull
                                    ) {
                                      html2 += ` ${leaveTypeName}`;
                                    }
                                  }
                                }

                                html2 = html2.trim();
                                return html2;
                              })()}
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "8%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {timePos2 ? timePos2 : "-"}
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "13%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {(() => {
                                let html2: any = "";
                                if (d.isSameOrBefore(today)) {
                                  if (isOutEarly && !leaveLastHalf) {
                                    html2 += ` ออกก่อนเวลา`;
                                  }
                                }
                                html2 = html2.trim();
                                return html2;
                              })()}
                            </Text>
                          </View>
                        );
                      }

                      // กรณีไม่พบข้อมูลการเข้างาน
                      if (!found) {
                        let leaveTypeName = null;
                        let leaveFull = false;

                        // ปรับ IIFE สำหรับตรวจสอบการลาในวันที่ไม่มีข้อมูลการเข้างาน
                        (() => {
                          dataMain.rows
                            .filter(
                              (data3: any) => data3.user_id == data1.user?.id
                            )
                            .forEach((data3: any) => {
                              data3.leave_detail.forEach((leave: any) => {
                                if (leave.status === "approved") {
                                  const startDate = Moment(leave.start_date);
                                  const endDate = Moment(leave.end_date);

                                  if (
                                    currentDate.isBetween(
                                      startDate,
                                      endDate,
                                      "day",
                                      "[]"
                                    )
                                  ) {
                                    if (leave.total_leave_time === "เต็มวัน") {
                                      leaveFull = true;
                                    }
                                    if (leave.leave_type_name) {
                                      leaveTypeName = leave.leave_type_name;
                                    }
                                  }
                                }
                              });
                            });
                        })();

                        // เช็ควันหยุด
                        let isRestDay = restDayList.find(
                          (v: any) => v.date == currentDate.format("YYYY-MM-DD")
                        );

                        // สร้าง View สำหรับวันที่ไม่มีข้อมูลการเข้างาน
                        html = (
                          <View key={day} style={{ flexDirection: "row" }}>
                            <View
                              style={{ width: "37%", marginLeft: 10 }}
                            ></View>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "10%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {getThaiDayName(
                                currentDate.format("YYYY-MM-DD")
                              ) +
                                " " +
                                formatDate(currentDate.format())}
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "8%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {"-"}
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "13%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {(() => {
                                let html2: any = "";

                                if (currentDate.isSameOrBefore(today)) {
                                  if (isRestDay) {
                                    html2 += ` วันหยุดนักขัตฤกษ์`;
                                  } else if (
                                    getBangkokMoment(currentDate).day() === 0
                                  ) {
                                    html2 += ` วันหยุดอาทิตย์`;
                                  } else if (
                                    getBangkokMoment(currentDate).day() === 6
                                  ) {
                                    html2 += ` วันหยุดเสาร์`;
                                  } else {
                                    if (!leaveFull) {
                                      if (
                                        [1, 2, 3, 4, 5].includes(
                                          getBangkokMoment(currentDate).day()
                                        )
                                      ) {
                                        html2 += ` ขาดงาน`;
                                      }
                                    }
                                    if (leaveTypeName) {
                                      html2 += ` ${leaveTypeName}`;
                                    }
                                  }
                                }

                                html2 = html2.trim();
                                return html2;
                              })()}
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "8%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {"-"}
                            </Text>
                            <Text
                              style={{
                                fontFamily: "kanit-200",
                                width: "13%",
                                fontSize: 10,
                                textAlign: "left",
                                marginLeft: 5,
                              }}
                            >
                              {""}
                            </Text>
                          </View>
                        );
                      }
                    });

                    return html;
                  })}

                  <View style={{ marginTop: 10 }} />
                </>
              );
            })}
          </View>
        </View>
      </Page>
    </Document>
  );

  const [showModal, setShowModal] = useState(false);
  const [pdfData, setPdfData] = useState<any>(null);
  const openModal = (data: any, data2: any) => {
    setIsMe(data2);
    setPdfData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setPdfData(null);
  };

  const fetchDataForModal = async (userId: string) => {
    try {
      // Call to setDataExport after fetching data
      const exportData =
        await ReportInOutLeaveService.getReportInOutLeaveDetail_Export({
          ...queryParamsExport,
          user_id: userId,
        });
      return exportData; // Set the export data
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getHolidaysActive();
  }, []);

  const [pdfExportData, setPdfExportData] = useState<any>(null);
  const [pdfExportIndex, setPdfExportIndex] = useState<number | null>(null);
  const [isExporting, setIsExporting] = useState(false);
  const [isExportingRow, setIsExportingRow] = useState<number | null>(null);

  return (
    <>
      <div className="d-flex justify-content-between py-4">
        <h2 className="text-mof-primary m-0">
          รายงานสถิติเข้า - ออกงานและการลา
        </h2>
        <a href="/report/report-in-out-leave/report-in-out-leave">
          <Button
            variant=""
            className="btn-action me-2 btn-outline-secondary"
            onClick={() => {}}
          >
            <FontAwesomeIcon icon={faCaretLeft} className="me-2" />
            ย้อนกลับ
          </Button>
        </a>
      </div>

      {loaderComponent}

      {/* <h5 className="text-mof-primary m-0">
        {
          Moment(queryParams.date).format('MM/') + (Moment(queryParams.date).year() + 543)
        }
      </h5>
      <br /> */}

      <div className="row">
        <div className="flex-row col-sm-12 col-md-3">
          <label className="form-label">วันที่</label>
          <MonthYearInput
            date={new Date(queryParams.date)}
            onChange={(date) => {
              const newDate = Moment(date).format("YYYY-MM");

              setQueryParams({
                ...queryParams,
                page: 1,
                date: newDate,
              });

              setQueryParamsExport({
                ...queryParamsExport,
                month: parseInt(Moment(newDate).format("MM")),
                year: parseInt(Moment(newDate).format("YYYY")),
              });
            }}
            required={true}
          />
        </div>

        {(() => {
          if (isAdmin) {
            return (
              <>
                <div className="flex-row col-sm-12 col-md-3">
                  <label className="form-label">สำนัก/ฝ่าย</label>
                  <InputSelect
                    value={queryParams.department_offices_name}
                    options={department_offices_name_Options}
                    placeholder=""
                    name="is_active"
                    onChange={(e: any) => {
                      setQueryParams((prevState) => {
                        return {
                          ...prevState,
                          department_offices_name: e.value.value || "",
                        };
                      });
                    }}
                    required={true}
                    isValidateError={false}
                  />
                </div>
              </>
            );
          }
        })()}
        {(() => {
          if (isAdmin) {
            return (
              <>
                <div className="flex-row col-sm-12 col-md-3">
                  <label className="form-label">กอง/กลุ่ม</label>
                  <InputSelect
                    value={queryParams.division_group_office_name}
                    options={division_group_office_name_Options}
                    placeholder=""
                    name="is_active"
                    onChange={(e: any) => {
                      setQueryParams((prevState) => {
                        return {
                          ...prevState,
                          division_group_office_name: e.value.value || "",
                        };
                      });
                    }}
                    required={true}
                    isValidateError={false}
                  />
                </div>
              </>
            );
          }
        })()}
        <div className="flex-row col-sm-12 col-md-3">
          <label className="form-label">แผนก</label>
          <InputSelect
            value={queryParams.structure_departments_name}
            options={departments_name_Options}
            placeholder=""
            name="is_active"
            onChange={(e: any) => {
              setQueryParams((prevState) => {
                return {
                  ...prevState,
                  structure_departments_name: e.value.value || "",
                };
              });
            }}
            required={true}
            isValidateError={false}
          />
        </div>
        <div className="flex-row col-sm-12 col-md-3">
          <label className="form-label">ตำแหน่ง</label>
          <InputSelect
            value={queryParams.position_name}
            options={position_name_Options}
            placeholder=""
            name="is_active"
            onChange={(e: any) => {
              setQueryParams((prevState) => {
                return {
                  ...prevState,
                  position_name: e.value.value || "",
                };
              });
            }}
            required={true}
            isValidateError={false}
          />
        </div>
        <div className="col-sm-12 col-md-3 d-flex align-items-end mt-4">
          <input
            className="form-control"
            type="text"
            value={queryParams.search as string}
            placeholder="ค้นหาจากชื่อ..."
            name="search"
            onChange={(e) => {
              setQueryParams((prevState) => {
                return {
                  ...prevState,
                  search: e.target.value || "",
                };
              });
            }}
          />
        </div>
        <div className="col-sm-12 col-md-3 d-flex align-items-end mt-3 gap-3">
          <Button
            variant="primary"
            type="button"
            className="d-block px-4"
            onClick={fetchData}
          >
            <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
          </Button>

          {/* {dataExportAll.count === 0 ? (
            // <Button type="button" className="btn-mof-primary btn btn-primary" onClick={() => { setQueryParamsExport({ ...queryParamsExport, user_id: '' }) }}>สร้าง PDF</Button>
            <Button
              type="button"
              className="btn-mof-primary btn btn-primary"
              onClick={() => {
                alert("WIP");
              }}
            >
              สร้าง PDF
            </Button>
          ) : (
            <PDFDownloadLink
              document={
                queryParamsExport.user_id === "" ? (
                  <PDF data={dataExportAll} />
                ) : (
                  <></>
                )
              }
              fileName={`รายงานสถิติเข้า-ออกงานและการลา (${
                thaiMonths[parseInt(Moment(queryParams.date).format("MM")) - 1]
              } ${Moment(queryParams.date).format("YYYY")}).pdf`}
            >
              {({ blob, url, loading, error }) =>
                loading ? (
                  <Button
                    type="button"
                    className="btn-mof-primary btn btn-primary"
                    disabled
                  >
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span className="sr-only">Loading...</span>
                  </Button>
                ) : (
                  <Button
                    type="button"
                    className="btn-mof-primary btn btn-primary"
                    onClick={() =>
                      setQueryParamsExport({
                        ...queryParamsExport,
                        user_id: "-",
                      })
                    }
                  >
                    ดาวน์โหลด PDF
                  </Button>
                )
              }
            </PDFDownloadLink>
          )} */}
        </div>
      </div>

      <div className="overflow-auto mt-3">
        <Table striped hover>
          <thead>
            <tr className="align-middle text-center">
              <th rowSpan={2} className="border min-150">
                Export PDF
              </th>
              <th rowSpan={2} className="border min-150">
                ชื่อ-สกุล
              </th>
              <th rowSpan={2} className="border min-150">
                สำนัก/ฝ่าย
              </th>
              <th rowSpan={2} className="border min-150">
                กอง/กลุ่ม
              </th>
              <th rowSpan={2} className="border min-150">
                แผนก
              </th>
              <th rowSpan={2} className="border min-150">
                ตำแหน่ง
              </th>
              <th
                colSpan={leave_type_Options.slice(1).length}
                className="border min-150"
              >
                วันลาประจำเดือน
                {
                  thaiMonths[
                    parseInt(Moment(queryParams.date).format("MM")) - 1
                  ]
                }{" "}
                {Moment(queryParams.date).format("YYYY")}
              </th>
              <th
                colSpan={leave_type_Options.slice(1).length}
                className="border min-150"
              >
                รวมวันลาทั้งหมด
              </th>
            </tr>
            <tr className="align-middle text-center">
              {leave_type_Options.slice(1).map((data: any, index: any) => {
                return (
                  <td
                    key={index}
                    style={{
                      backgroundColor: "#6C757D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                    className="border"
                  >
                    {data.label}
                  </td>
                );
              })}
              {leave_type_Options.slice(1).map((data: any, index: any) => {
                return (
                  <td
                    key={index}
                    style={{
                      backgroundColor: "#6C757D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                    className="border"
                  >
                    {data.label}
                  </td>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((data: any, index: any) => {
              return (
                <tr
                  key={index}
                  className="text-center cursor-pointer"
                  onClick={() => {
                    if (isExportingRow === index) return; // ถ้าแถวนี้กำลัง export ไม่ต้องเปิด modal
                    startLoading();
                    fetchDataForModal(data.user_id)
                      .then((dataExport) => {
                        stopLoading();
                        openModal(dataExport, data);
                      })
                      .catch((error) => {
                        stopLoading();
                        console.error("Error fetching data:", error);
                      });
                  }}
                >
                  <td align="center">
                    <Button
                      type="button"
                      variant="primary"
                      className="d-block btn-export-pdf"
                      onClick={async (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        setIsExportingRow(index);
                        setIsExporting(true);
                        setPdfExportIndex(index);
                        startLoading();
                        try {
                          const exportData = await fetchDataForModal(
                            data.user_id
                          );
                          setPdfExportData(exportData);
                          setTimeout(() => {
                            if (refButtonExport.current[index]) {
                              refButtonExport.current[index]?.click();
                            }
                            setIsExporting(false);
                            setPdfExportIndex(null);
                            setPdfExportData(null);
                            setIsExportingRow(null); // reset flag
                            stopLoading();
                          }, 500);
                        } catch (err) {
                          setIsExporting(false);
                          setPdfExportIndex(null);
                          setPdfExportData(null);
                          setIsExportingRow(null); // reset flag
                          stopLoading();
                        }
                      }}
                    >
                      <FontAwesomeIcon icon={faFileExport} />
                    </Button>
                    <PDFDownloadLink
                      document={
                        pdfExportData && pdfExportIndex === index ? (
                          <PDF data={pdfExportData} />
                        ) : (
                          <></>
                        )
                      }
                      fileName={`รายงานสถิติเข้า-ออกงานและการลา (${
                        data.prefix_name_th +
                        data.firstname_th +
                        " " +
                        data.lastname_th
                      }).pdf`}
                    >
                      {(({ blob, url, loading, error }: any) => (
                        <span
                          ref={(el: any) =>
                            (refButtonExport.current[index] = el)
                          }
                        ></span>
                      )) as any }
                    </PDFDownloadLink>
                  </td>
                  <td>
                    {data.prefix_name_th +
                      data.firstname_th +
                      " " +
                      data.lastname_th}
                  </td>
                  <td>
                    {data.job?.department_offices_name
                      ? data.job?.department_offices_name
                      : "-"}
                  </td>
                  <td>
                    {data.job?.division_group_office_name
                      ? data.job?.division_group_office_name
                      : "-"}
                  </td>
                  <td>
                    {data.job?.structure_departments_name
                      ? data.job?.structure_departments_name
                      : "-"}
                  </td>
                  <td>
                    {data.job?.position_name ? data.job?.position_name : "-"}
                  </td>
                  {leave_type_Options
                    .slice(1)
                    .map((leave_type: any, index: any) => {
                      for (let i = 0; i < data.leave?.length; i++) {
                        if (leave_type.value == data.leave[i]?.id) {
                          return <td key={index}>{data.leave[i]?.count}</td>;
                        }
                      }
                      return <td>0</td>;
                    })}
                  {leave_type_Options
                    .slice(1)
                    .map((leave_type: any, index: any) => {
                      for (let i = 0; i < data.leave_all?.length; i++) {
                        if (leave_type.value == data.leave_all[i]?.id) {
                          return (
                            <td key={index}>{data.leave_all[i]?.count}</td>
                          );
                        }
                      }
                      return <td>0</td>;
                    })}
                </tr>
              );
            })}
            {tableRowNoData()}
          </tbody>
        </Table>
      </div>

      <div className="">
        <PaginationForm
          current_page={queryParams.page}
          count={data.count}
          page_size={queryParams.page_size}
          onChangePageSize={onChangePageSize}
          onChangePage={onChangePage}
        />
      </div>

      {showModal && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog modal-lg" style={{ maxWidth: "80%" }}>
            <div className="modal-content">
              <div className="modal-header justify-content-end">
                <button
                  type="button"
                  className="btn btn-white text-danger "
                  onClick={closeModal}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
              <div className="modal-body">
                <DivReport data={pdfData} />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger text-white"
                  onClick={closeModal}
                >
                  ปิด
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportInOutLeaveDetailPage;
